module.exports = __webpack_public_path__ + "f435e9f0c9c7f8a3d42521b033b49a72.pdf";